import styled from 'styled-components';

import colors from '../../style/colors';
import BaseCard, { BaseCardProps } from './base-card';

const ShadowCard = styled(BaseCard)<BaseCardProps>`
  transition: all 600ms ease;
  background: ${colors.white};
  box-shadow: 0px 0px 10px 0px #0000000d;
  border: 1px solid white;
  &:hover:not(.disabled):not([disabled]) {
    box-shadow: 0px 0px 30px 0px #0000000d;
    cursor: pointer;
  }

  &:focus-visible,
  &.active {
    border-color: ${props => props.theme.actionColor};
  }
`;

export default ShadowCard;
